export default __webpack_public_path__ + "479967f644b9692dd4ab9d936e0f33c8.png";